"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONSOLE_LOGGER = void 0;
/**
 * Implementation of GoblinLogger that prints stuff to the console
 */
exports.CONSOLE_LOGGER = {
    debug(...messages) {
        // debug - don't print anything
        return "";
    }, error(...messages) {
        // eslint-disable-next-line no-console
        console.error(messages);
        return "";
    }, info(...messages) {
        // eslint-disable-next-line no-console
        console.log(messages);
        return "";
    }, warn(...messages) {
        // eslint-disable-next-line no-console
        console.warn(messages);
        return "";
    }
};
//# sourceMappingURL=loggingTypes.js.map